import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import formdata from './formdata'

const state = {
   
    data: {
        name:'',  
        number:'',
        entities:[],
        entity_ids:[],
        company:null,
        company_ids:[],
        started_at:null,
        ended_at:null
    },    
    projects:[],                
    
};

export default {
  namespaced: true,
  modules: {
        formdata: formdata,
        
    },
  state,
  actions,
  getters,
  mutations,
};